let Paginator = require('@/mixins/Paginator');

module.exports = {

    mixins: [Paginator],

    data() {
        return {
            isLoading: false,
            projects: [],
            filters: null,
        }
    },

    created() {
        this.paginator.current_page = this.getInitPageNumber();
        this.filters = this.dataFilters()
    },

    mounted() {
        this.requestPaginate();
    },

    methods: {

        requestPaginate: _.debounce(function (page) {
            this.loadFilters(page);
            this.fetchProjects();
        }, 300),

        fetchProjects() {
            this.isLoading = true
            var params = jQuery.param(Storage.get(App.config.userProjectsKey));
            App.request().get(`/projects?${params}`).then(response => {
                this.paginator = response.data;
                this.projects = this.paginator.data;
                this.isLoading = false
            }).catch(errors => {
                this.isLoading = false
                console.log(errors)
            })
        },

        loadFilters(page) {
            Storage.set(App.config.userProjectsKey, {...this.filters, ...{page: (page ? page : this.paginator.current_page)}})
            // this.request = new Request(Storage.get(App.config.userProjectsKey));
        },

        getInitPageNumber() {
            return !!Storage.get(App.config.userProjectsKey) ? Storage.get(App.config.userProjectsKey).page : 1;
        },

        dataFilters() {
            if (!!Storage.get(App.config.userProjectsKey)) {
                return Storage.get(App.config.userProjectsKey)
            }
            return {
                query: '',
                energy_code: '',
                user_id: '',
                searchKey: '',
                page: this.paginator.current_page,
                with: '',
            };
        },
    }
}
